import $ from 'jquery';
import { useCallback, useEffect, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import CssLoader from '../../../components/cssloader/CssLoader';
import Sidebar from '../../../components/Sidebar';
import { CategoryMatch, SubGroup } from "../../../helpers/interfaces/category";
import { IMatchData } from "../../../helpers/interfaces/matchData";
import { IRestTeam, ICategoryGroup } from "../../../helpers/interfaces/ranking";
import { matchesService } from '../../../services/MatchesService';
import { rankCategoryService } from "../../../services/RankCategoryService";
import RankGroupTable from '../common/RankGroupTable';
import RankScorersTable from '../common/RankScorersTable';
import Advertising from '../../../common/Advertising';
import { useMenuSingleton } from '../../../singleton/menuSingleton';
import { menuItem, TypeToCategoria } from '../../../helpers/interfaces';
import Link from '../../../common/Link';
import CategoryMatchesTable from './CategoryMatchesTable';
import { CalendarIcon } from '../../../components/Icons';
import SelectSeason from '../../../common/SelectSeason';
import SendResultModal from '../../PartiteOdierne/SendResultModal';
import moment from 'moment';
import 'moment/locale/it';
import "./ClassificaCategoria.css";
import PageMeta from "../../../components/PageMeta";

export default function ClassificaCategoriaPage(props: menuItem) {
    let location = useLocation();

    const { getMenu, getTypeToCategoriaMap } = useMenuSingleton();
    const typeToCategoriaMap: Record<string, TypeToCategoria> = getTypeToCategoriaMap(getMenu().data);
    const typeToCategoria: TypeToCategoria  = typeToCategoriaMap[props.type];

    if (location.state == null && typeToCategoria && typeToCategoria.categoria) {
        location.state = {categoryName: typeToCategoria.label, categoryId: typeToCategoria.categoria, groupId: null}
    }

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [title, setTitle] = useState<string>("");
    const [openResultsModal, setOpenResultsModal] = useState(false);
    const [expanded, setExpanded] = useState<boolean>(false);

    const [allGroups, setAllGroups] = useState<SubGroup[]>([]);
    const [groupDays, setGroupDays] = useState<number[]>([]);
    const [currentGroup, setCurrentGroup] = useState<ICategoryGroup | undefined>(undefined);
    const [currentGroupId, setCurrentGroupId] = useState<string | undefined>(
        location.state?.groupId ? location.state.groupId : undefined
    );
    const [currentGroupDay, setCurrentGroupDay] = useState<number>(0);
    const [currentMatch, setCurrentMatch] = useState<IMatchData | undefined>(undefined);
    const [groupMatches, setGroupMatches] = useState<CategoryMatch[]>([])
    const [listaSquadreRiposo, setListaSquadreRiposo] = useState<IRestTeam[]>([])
    const [isShown, setIsShown] = useState<boolean>(false);
    const [currentSeason, setCurrentSeason] = useState<string>("");
    const [years, setYears] = useState<string[]>([]);
    const [labelGiornate, setLabelGiornate] = useState<{ [key: number]: string }>({});
    const [expandedMatchId, setExpandedMatchId] = useState<number | null>(null);

    const fetchGroup = useCallback(async (
        groupId: string,
        currentSeason?: string,
    ) => {
        const group = await rankCategoryService.getGroup(groupId, currentSeason);

        if (group && typeof group !== "string") {
            setCurrentGroup(group);
            setCurrentGroupDay(Number(group.giornata));
            setCurrentSeason(group.annoRiferimento);
            setYears(group.anniRiferimento);
            setGroupDays([...group.giornateAndata, ...group.giornateRitorno]);
            setGroupMatches(group.calendario);
            setListaSquadreRiposo(group.listaSquadreRiposo);
            setLabelGiornate(group.labelGiornate);
        }
    }, [])

    const fetchGroups = useCallback(async (categoryId: number) => {
        const groups = await rankCategoryService.getCategoryGroups(categoryId)
        if (groups && typeof groups !== "string") {
            setAllGroups(groups);
            const locationGroup = (async() => {
                if (!location.state?.groupId) {
                    location.state.groupId = groups[0].id;
                    setCurrentGroupId(groups[0].id)
                }
            });

            await locationGroup().then(async () => {
                await fetchGroup(location.state?.groupId)
            });
        }
        // eslint-disable-next-line
    }, [fetchGroup])

    const fetchGroupDay = async (
        groupDay: number,
        season?: string,
        groupId?: string
    ) => {
        if (currentGroupId) {
            const calendarList = await rankCategoryService.getCalendarList(
                currentGroupId,
                season ?? currentSeason,
                groupDay
            );

            if (calendarList && typeof calendarList !== "string") {
                // setCurrentGroup(group)
                // setGroupDays([...group.giornateAndata, ...group.giornateRitorno])
                setListaSquadreRiposo(calendarList.listaSquadreRiposo);
                setGroupMatches(calendarList.listaCalendari);
            }
        }
    }

    useEffect(() => {
        if (location.state?.categoryName) {
            setTitle(location.state.categoryName)
        }
    }, [location.state?.categoryName])

    useEffect(() => {
        (async() => {
            setIsLoading(true);
    
            if (location.state?.categoryId) {
                await fetchGroups(location.state.categoryId)
            }

            setIsLoading(false);
        })();
    }, [location.state?.categoryId, fetchGroups])

    const setCellsWidth = () => {
        let tableWidth = $('#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile').width()
        let count = $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr:first > td").length;
        if (count === 4 && tableWidth) {
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='0']").css({ width: (tableWidth / 100 * 20) })
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='1']").css({ width: (tableWidth / 100 * 50) })
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='2']").css({ width: (tableWidth / 100 * 15) })
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='3']").css({ width: (tableWidth / 100 * 15) })
        }
        if (count === 3 && tableWidth) {
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='0']").css({ width: (tableWidth / 100 * 25) })
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='1']").css({ width: (tableWidth / 100 * 50) })
            $("#tab_rank_groups div.rank_groups_table table > tbody.tbody-mobile > tr > td[data-index='2']").css({ width: (tableWidth / 100 * 25) })
        }
    }

    useEffect(() => {
        $('.send-results-btn').off().on('click', async (e: { currentTarget: { id: string } }) => {
            const matchId = e.currentTarget.id.split("-").pop();
            if (matchId) {
                setIsLoading(true);

                try {
                    const selectedMatch = await rankCategoryService.getMatch(matchId);
                    if (selectedMatch && typeof selectedMatch !== "string") {
                        let currentMatch = { ...selectedMatch }
                        const teamA = await matchesService.getTeamData(selectedMatch.idSquadraA.toString());
                        const teamB = await matchesService.getTeamData(selectedMatch.idSquadraB.toString());
                        if (teamA && typeof teamA !== "string" && teamA !== undefined)
                            currentMatch.giocatoriA = teamA.giocatori.filter(player => Boolean(player.attivo))
                        if (teamB && typeof teamB !== "string" && teamB !== undefined)
                            currentMatch.giocatoriB = teamB.giocatori.filter(player => Boolean(player.attivo))
                        setCurrentMatch(currentMatch);
                        setOpenResultsModal(true);
                    }
                } finally {
                    setIsLoading(false);
                }
            }
        });
        setCellsWidth()
        $(window).on('resize', function () {
            let width = $(window).width();
            if (width && width < 540) {
                setCellsWidth()
            }
            if ($(this).width() !== width) {
                width = $(this).width();
            }
        });
    })

    const selectGroup = async (
        groupId: string,
        currentSeason: string
    ) => {
        await (async () => {
            setGroupDays([]);
            setCurrentGroupId(groupId);
        })().then(async() => {
            setIsLoading(true);

            await fetchGroup(groupId, currentSeason)

            setIsLoading(false)
        });
    };

    const selectGroupDay = async (groupDay: number) => {
        setCurrentGroupDay(groupDay);

        setIsLoading(true);

        await fetchGroupDay(groupDay);

        setIsLoading(false)
    };

    const handleSeasonChange = async(value: any) => {
        setCurrentSeason(value)

        setIsLoading(true);
        if (currentGroupId) {
            await selectGroup(currentGroupId, value)
        }
        setIsLoading(false)
    }

    return <>
        <PageMeta
            title={`${title} - Calcio a 5 Live`}
            description=""
            image=""
            url={document.location.href}
            type=""
        />
        <div className="rank-category-content rank-category-page">
            <SendResultModal
                showModal={openResultsModal}
                currentMatch={currentMatch}
                onCloseHandler={() => {
                    setOpenResultsModal(false)
                }}
            />
            <Row>
                <Col>
                    <h1>Classifica {title}</h1>
                </Col>
            </Row>
            <hr />
            {
                allGroups.length > 0 ?
                    <div id="rank_groups" className='position-relative'>
                        <Row>
                            <Col className="order-md-2" xs="12" md="2">
                                <Dropdown id="calendarDropdown"
                                    show={isShown}
                                    onToggle={(isOpen, _metadata) => { setIsShown(isOpen) }}
                                    className='calendarDropdown position-absolute'
                                    style={{right: 0}}
                                >
                                    {
                                        !isShown ?
                                            <>
                                                <Dropdown.Toggle
                                                    as="div"
                                                    className="calendar-toggle"
                                                    id="date-dropdown"
                                                >
                                                    <span className="calendar-tag me-2">{currentSeason}</span>
                                                    <CalendarIcon />
                                                </Dropdown.Toggle>
                                            </>
                                        : <button
                                            className="close-btn"
                                            onClick={() => { setIsShown(false)} }
                                        >×</button>
                                    }
                                    <Dropdown.Menu className="dropdown-menu p-0" style={{right: -1, ...isShown ? { top: 38 } : {}}}>
                                        <div className="calendar-dropdown">
                                            <SelectSeason
                                                seasons={years}
                                                onSeasonChange={handleSeasonChange}
                                                currentSeason={currentSeason}
                                            />
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                            <Col
                                id="tab_rank_category_groups"
                                className="mt-3 order-md-1"
                                xs="12"
                                md="10"
                            >
                            {allGroups && allGroups.length > 0 ? allGroups.map((
                                    group: SubGroup,
                                    groupIndex: number
                                ) => {
                                    return <Link
                                        key={groupIndex}
                                        onClick={async () => {
                                            setGroupDays([]);
                                            setCurrentGroupId(group.id);
                                            await selectGroup(group.id, currentSeason)
                                        }}
                                        className={'me-3 pb-3 d-inline-block' +
                                            (group.id === currentGroupId
                                                ? ' active' : '')
                                        }
                                    >
                                        {group.nomeGirone}
                                    </Link>
                                }) : <>Nessun girone disponibile</>
                            }
                            </Col>
                        </Row>
                        <hr />
                        <div className="mt-3">
                            <div>
                                <h3>Risultati delle partite</h3>
                            </div>
                            <div id="tab_rank_group_days" className="mt-3">
                                {
                                    groupDays && groupDays.length > 0 ? groupDays.map((
                                        groupDay: number,
                                        groupIndex: number
                                    ) => {
                                        const label = labelGiornate?.[groupDay] || groupDay;

                                        return <Link
                                            key={groupIndex}
                                            onClick={async () => {
                                                await selectGroupDay(groupDay)
                                            }}
                                            className={'me-3' +
                                                (groupDay === currentGroupDay
                                                ? ' active' : '')
                                            }
                                        >
                                            {label}
                                        </Link>
                                    }) : <>Nessuna giornata disponibile</>
                                }
                            </div>
                            <hr />
                            <div className="mt-3">
                                <h4>{currentGroupDay > 0
                                    ? (labelGiornate?.[currentGroupDay] || currentGroupDay + 'ª Giornata')
                                    : 'Giornata non disponibile'
                                }</h4>
                                <CategoryMatchesTable
                                    groupLabel={title}
                                    group={currentGroup}
                                    day={currentGroupDay}
                                    groupMatches={groupMatches}
                                    listaSquadreRiposo={listaSquadreRiposo}
                                    expandedMatchId={expandedMatchId}
                                    onToggleExpand={setExpandedMatchId}
                                />
                            </div>
                            <Advertising code="new_banner_classifica_1" as="div" className='text-center py-4' />
                            <Row id="page_content">
                                <Col id="content" className="category-content pe-4" xs={12} lg={9}>
                                    {currentGroup?.hasClassifica && (
                                        <>
                                            <RankGroupTable groupName={title} currentGroup={currentGroup} />
                                            <Advertising code="new_banner_classifica_2" as="div" className='text-center py-4' />
                                            </>
                                        )}
                                    <RankScorersTable currentGroup={currentGroup} expanded={expanded} setExpanded={setExpanded} />
                                </Col>
                                <Col id="sidebar" className="py-3" xs={12} lg={3}>
                                    <Sidebar />
                                </Col>
                            </Row>
                        </div>
                    </div>
                : <Row className="d-flex justify-content-center">
                    Nessun girone presente
                </Row>
            }

            <CssLoader active={isLoading} text="Caricamento della competizione in corso..." />
        </div>
    </>
}